import { Grid } from '@mantine/core'
import { translate } from 'i18n/i18n'
import React from 'react'
import { serviceCenterStore } from '../../../store/serviceCenterStore'
import { TargetPest } from '../../Shared/TargetPest/TargetPest'

export const TrapConfigDetail: React.FC = () => {
  const selectedNodePrimaryLure = serviceCenterStore.useSelector(
    serviceCenterStore.selectors.getSelectedEquipmentPrimaryLure,
  )

  return (
    <>
      <TargetPest />

      <Grid.Col span={4}>{translate.phrases.placeholder('Lure Type')}</Grid.Col>
      <Grid.Col span={8}>
        {selectedNodePrimaryLure
          ? translate.phrases.placeholder(selectedNodePrimaryLure.lureName)
          : translate.phrases.placeholder('-')}
      </Grid.Col>
    </>
  )
}
